// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'user',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'hotel',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'order_detail',
    label: '',
    Object: 'value',
    width: '260'
  }, {
    prop: 'contact_info',
    label: '',
    Object: 'value',
    width: '130'
  }, {
    prop: 'status',
    label: '',
    Object: 'value',
    width: '130'
  }]
}
